export default __webpack_public_path__ + "static/media/erx-delivery-payment-icon.9b174bbd.svg";